import { SaleFormInput } from '@src/core/buyerApiClient';
import { groupTariffUnits, formInputGroupKey, type SaleItemFormInputGroup } from '@src/domains/orders';

export interface QueuedTariff {
  /** The cart item the tariff belongs to; the expanded accordion follows it. */
  saleItemId: string;
  inputs: SaleFormInput[];
  /** 1-based position of this unit within its tariff; becomes the "1/2" badge. */
  unitIndex: number;
  /** Quantas unidades daquela tarifa foram compradas. */
  unitCount: number;
}

type BuildTariffFormInputQueueParams = {
  saleGroups: SaleItemFormInputGroup[];
  startKey: string;
  /** When set, only these tariffs are queued. Used to reopen on the ones a 422 rejected. */
  onlyKeys?: Set<string>;
};

/**
 * The queue the modal walks. It crosses cart items: finishing the last tariff of one
 * accordion moves straight into the first of the next, without closing the modal.
 */
export const buildTariffFormInputQueue = (params: BuildTariffFormInputQueueParams): QueuedTariff[] => {
  const { saleGroups, startKey, onlyKeys } = params;

  const all = saleGroups.flatMap((group) =>
    groupTariffUnits(group.formInputGroups).flatMap((tariff) =>
      tariff.units.map((inputs, index) => ({
        saleItemId: group.saleItemId,
        inputs,
        unitIndex: index + 1,
        unitCount: tariff.units.length,
      })),
    ),
  );

  const eligible = onlyKeys ? all.filter((entry) => onlyKeys.has(formInputGroupKey(entry.inputs))) : all;

  const startIndex = eligible.findIndex((entry) => formInputGroupKey(entry.inputs) === startKey);

  return eligible.slice(startIndex === -1 ? 0 : startIndex);
};
